import { useParams } from "react-router-dom"

export const DoiPlaceholder = () => {
    const params = useParams();
    return <div className="xl:ml-[20vw]">
        <div className="flex flex-col">
            <div className="text-blue-950 mt-10"><h1>DOI Page Dutch Marine Science Portal</h1></div>
            <div>A page in style </div>
            <div className="pr-4">DOI Placeholder for {params.title}</div>
            <div>
                <p>All meta data for {params.title}</p>
                <a href={params.doi}>{params.doi}</a>
            </div>
        </div>
    </div>
}